<template>
  <QuizStatics>
    <template #image>
      <div class="correct-rate-slide">
        <aha-progress-circle
          v-if="shareType === 'correct-rate'"
          progress-bar-color="#33C173"
          :percent="roundedCorrectRate"
          :radius="45"
          :ring-width="9"
          inner-box-shadow="inset 0px 6px 16px rgba(51, 193, 115, 0.19)"
          box-shadow="0px 6px 16px rgba(51, 193, 115, 0.19)"
        >
          <aha-icon
            class="circle-check"
            name="circle-check-with-border"
          />
          <aha-icon
            name="blink"
            width="10"
            height="12"
            class="star-left"
            viewBox="0 0 12 14"
          />
          <aha-icon
            name="blink"
            class="star-top"
            width="12"
            height="14"
            viewBox="0 0 12 14"
          />
          <aha-icon
            name="blink"
            width="16"
            height="18"
            class="star-right"
            viewBox="0 0 12 14"
          />
        </aha-progress-circle>
      </div>
    </template>
    <template #body>
      <div class="correct-rate-slide__heading">
        <span class="bold">{{ quizBragCorrectRateTextContent.title }}</span>
        <span class="pl-2">{{ quizBragCorrectRateTextContent.emoji }}</span>
      </div>
      <div class="correct-rate-slide__text" v-html="quizBragCorrectRateTextContent.content" />
    </template>
  </QuizStatics>
</template>
<script>

import {
  getQuizBragCorrectRateTextContent,
} from '@/components/utils/leaderboard'
import QuizStatics from '@/components/quiz/QuizStatics.vue'
import Util from '@/util'

export default {
  components: {
    QuizStatics,
  },
  props: {
    audience: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isTeamQuiz: {
      type: Boolean,
      required: true,
      default: false,
    },
    totalQuizCount: {
      type: Number,
      required: true,
      default: 0,
    },
    roundedCorrectRate: {
      type: Number,
      required: true,
      default: 0,
    },
    shareType: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    quizBragCorrectRateTextContent() {
      return getQuizBragCorrectRateTextContent(
        this.totalQuizCount,
        Util.roundNumberWithNDecimals(this.roundedCorrectRate, 2, true) || 0,
        this.isTeamQuiz,
        this,
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.correct-rate-slide__text {
  line-height: 1.5;
}

.correct-rate-slide__heading {
  margin-top: 0;
  margin-bottom: 0.25rem;
  font-size: 24px;
}

.slide-title-correct-rate-emoji {
  font-size: 20px;
}

.correct-rate-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 110px;

  .star-left, .star-top, .star-right, .check {
    position: absolute;
    color: #FFC666;
  }

  .circle-check {
    position: absolute;
    color: #33C173;
    top: 50%;
    left: 50%;
    color: #33C173;
    transform: translate(-50%, -50%);
  }

  .star-left {
    left: -15px;
    bottom: 0;
  }
  .star-top {
    top: 0;
  }
  .star-right {
    right: -20px;
    bottom: 10px;
  }
}
</style>
